import { animate, AnimationStyleMetadata, transition, trigger } from '@angular/animations';

export const flyInOutChild = (inactiveStyle: AnimationStyleMetadata, timing: string) =>
  trigger('flyInOutChild', [
    transition('void => *', [inactiveStyle, animate(timing)]),
    transition('* => void', [animate(timing, inactiveStyle)]),
  ]);
